import type { MediaAsset, MediaDerivative } from '@/lib/api/types';

/** A generated file of an asset by label (`thumb`, `og`, `icon_32`, …), if it exists. */
export function derivative(
  asset: Pick<MediaAsset, 'derivatives'> | undefined | null,
  label: string,
): MediaDerivative | undefined {
  return Array.isArray(asset?.derivatives) ? asset.derivatives.find((d) => d.label === label) : undefined;
}

/**
 * The URL to show a small preview from: the 400 px `thumb` resize when the upload made one,
 * else the original (an image narrower than 400 px, or an SVG, has no resize).
 */
export function thumbUrl(asset: Pick<MediaAsset, 'derivatives' | 'url'>): string {
  return derivative(asset, 'thumb')?.url || asset.url;
}
